module.exports = __webpack_public_path__ + "static/media/Room-3.4bd1e725.jpg";